"use client";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useJobStore } from "../../store/jobStore";
import JobCard from "../molecules/JobCard";
import SectionBox from "../layout/SectionBox";
import PageLoader from "../../components/atoms/PageLoader";

export default function JobListingGridHome() {
  const { jobs, fetchJobs, resetFilters  } = useJobStore();
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(6);
  const location = useLocation();

  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  useEffect(() => {
    
    resetFilters(); 
    fetchJobs(lang).finally(() => setLoading(false)); // fetch sesuai bahasa
  }, [lang, fetchJobs]);

  const visibleJobs = jobs.slice(0, visibleCount);
  const hasMore = visibleCount < jobs.length;

  return (
    <section className="w-full pt-6 relative">
      {loading && <PageLoader />}

      <div className="container-section mx-auto px-6">
        <SectionBox
          title={
            lang === "id"
              ? "Peluang yang tersedia untuk bergabung dengan kami."
              : "Available opportunities to join with us"
          }
          titleAlign="left"
          titleClassName="text-2xl md:text-3xl text-white"
        >
          {/* EMPTY STATE */}
          {!loading && jobs.length === 0 && (
            <div className="flex flex-col items-center justify-center py-20 text-center">
              <p className="text-lg text-black font-medium">
                {lang === "id"
                  ? "Belum ada lowongan yang tersedia"
                  : "No jobs available"}
              </p>
              <p className="text-sm text-black mt-2">
                {lang === "id"
                  ? "Silakan cek kembali nanti"
                  : "Please check back later"}
              </p>
            </div>
          )}

          {/* Grid Job Cards */}
          {!loading && jobs.length > 0 && (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {visibleJobs.map((job) => (
                  <JobCard
                    key={job.id}
                    id={job.id}
                    title={job.title}
                    description={job.description}
                    education={job.education}
                    yearExperience={job.yearExperience}
                    priceRange={job.priceRange}
                    company={job.company}
                    company_logo={job.company_logo}
                    location={job.location}
                    variant="square"
                  />
                ))}
              </div>

              {/* Load More */}
              {hasMore && (
                <div className="flex justify-center mt-10">
                  <Link
                    to={`/${lang}/jobs`}
                    className="px-6 py-2 bg-[#123b7c] text-white rounded-full font-medium hover:bg-[#0e2f66] transition"
                  >
                    Load More
                  </Link>
                </div>
              )}
            </>
          )}
        </SectionBox>
      </div>
    </section>
  );
}
